import React from 'react';

import CTAButton from 'src/components/cta-button/CTAButton';

import GenericIcon from 'src/components/generic-icon/GenericIcon';

export default ({ labels, actions, goToSimple }) => (
  <>
    <CTAButton
      id="sfs-go-to-simple-btn"
      action={goToSimple}
      className="btn-as-text onResult"
      label=""
    >
      <GenericIcon layout='i' className="chevron-left-icon"></GenericIcon>
      <span>{labels.searchTaiga.goToSimpleSearch}</span>
    </CTAButton>
    <CTAButton
      id="sfs-edit-btn"
      label={labels.searchTaiga.editSearch}
      action={actions.taigaSearchClear}
    />
  </>
);
